import React, { Component } from 'react'
import PropTypes from "prop-types"
import TableHead from "./TableHead"
import { listLocal } from "../../../helpers/filtersTable"
import classNames from 'classnames'
import { Modal, Button, Table, Spin, message, Popconfirm } from 'antd'
import { UploadOutlined, LoadingOutlined, DeleteOutlined, EyeTwoTone } from '@ant-design/icons'
import { EditableRow, EditableCell } from './CustomTableVariant'
import { uploadImageSku, updateSkuSize } from "../../../../services/api/apiSku"
class SkuSizeTabs extends Component {
    state = {
        tabs: ['tab-1', 'tab-2'],
        carrier: 'default',
        objectType: 'shipping-carrier',
        objectName: 'default',
        isOpenDescribeVariant: false,
        isLoading: false,
        isOpenPreview: false,
        imageSelect: '',
        loading: false
    }

    inputFileRefVariant = {}

    antIcon = (
        <LoadingOutlined
            style={{
                fontSize: 24,
            }}
            spin
        />
    )

    _handleAddImage = (id) => {
        this.inputFileRefVariant[id].click()
    }

    _handleRemoveImage = (id, imageUrl) => {
        const { sizes, onChangeSizes } = this.props
        const newSizes = sizes.map(i => {
            const { package_mockup = [] } = Object.assign({}, i)
            const newPackageMockup = package_mockup.filter(o => o !== imageUrl)
            if (i._id === id) {
                return {
                    ...i,
                    isChange: true,
                    package_mockup: newPackageMockup
                }
            }
            return i
        })
        onChangeSizes(newSizes)
    }

    _handleFileChange = async (event, variantId) => {
        this.setState({ isLoading: true })
        const file = event.target.files[0]
        const validImageTypes = ['image/png', 'image/jpeg', 'image/jpg']
        const { sizes, onChangeSizes } = this.props

        if (!file) return

        const maxSize = 10 * 1024 * 1024 // 10MB
        if (file && file.size > maxSize) {
            message.error('File phải nhỏ hơn 10MB.')
            this.setState({ isLoading: false })
            return
        }

        if (file && !validImageTypes.includes(file.type)) {
            message.error('Chỉ hỗ trợ định dạng [image/png,image/jpeg,image/jpg].')
            this.setState({ isLoading: false })
            return
        }

        const newSizes = sizes.map(item => {
            if (item._id === variantId) {
                return {
                    ...item,
                    isLoading: true,
                }
            }
            return { ...item, isLoading: false }
        })
        onChangeSizes(newSizes)

        try {
            const formData = new FormData()
            file && formData.append('file', file)
            variantId && formData.append('objectId', variantId)
            formData.append('objectName', 'SkuSize')

            const { data } = await uploadImageSku(formData)
            const { data: res, success, message: mess } = Object.assign({}, data)
            if (!success) return message.error(mess)

            const newSizes = sizes.map(item => {
                const { package_mockup = [] } = Object.assign({}, item)
                if (item._id === variantId) {
                    return {
                        ...item,
                        isChange: true,
                        isLoading: false,
                        package_mockup: [
                            ...package_mockup,
                            res
                        ]
                    }
                }
                return item
            })

            onChangeSizes(newSizes)
            if (this.inputFileRefVariant[variantId]) this.inputFileRefVariant[variantId].value = null
        } catch (error) {
            message.error(error.message)
        } finally {
            this.setState({ isLoading: false })
        }
    }

    columns = [
        {
            title: <span className='font-weight-bold'>Size</span>,
            dataIndex: 'sku',
            key: 'sku',
            className: 'table-cell-sku'
        },
        {
            title: <span className='font-weight-bold'>Mô tả đóng gói</span>,
            dataIndex: 'package_description',
            key: 'package_description',
            editable: true,
            render: (_, r) => {
                const { package_description = '' } = Object.assign({}, r)
                if (!!package_description && package_description.trim().length < 20) return <span className='text-danger'>Mô tả đóng gói tối thiểu 20 ký tự</span>
                if (!!package_description && package_description.trim().length > 500) return <span className='text-danger'>Mô tả đóng gói không được quá 500 ký tự</span>
                return package_description
            },
            className: 'table-cell-description'
        },
        {
            title: <span className='font-weight-bold'>Ảnh variant</span>,
            dataIndex: 'package_mockup',
            key: 'package_mockup',
            render: (_, r) => {
                const { _id, package_mockup = [], isLoading = false } = Object.assign({}, r)
                const { imageSelect, isOpenPreview } = this.state
                return (
                    <div className={`d-flex align-items-center justify-content-center`}>
                        {
                            !!package_mockup.length &&
                            <div className="d-flex align-items-center">
                                {
                                    package_mockup.map((item, index) => (
                                        <div className={`image-item-upload position-relative ${index < 2 && 'mr-3'}`} key={item}>
                                            <img
                                                src={item}
                                                alt="preview"
                                                style={{ maxWidth: 'none', maxHeight: 'none' }}
                                                loading='lazy'
                                            />
                                            {!isLoading && <Popconfirm
                                                placement="topRight"
                                                title="Bạn chắc chắn muốn xóa ảnh này?"
                                                onConfirm={() => this._handleRemoveImage(_id, item)}
                                                okText="Xóa"
                                                cancelText="Không"
                                                zIndex={"10000"}
                                            >
                                                <DeleteOutlined className='delete-image-item' />
                                            </Popconfirm>}
                                            <EyeTwoTone
                                                className='eyes-image-item'
                                                onClick={() => this.setState({ isOpenPreview: true, imageSelect: item })}
                                            />
                                            <Modal
                                                visible={isOpenPreview && item === imageSelect}
                                                onCancel={() => this.setState({ isOpenPreview: false, imageSelect: '' })}
                                                closable={false}
                                                footer={false}
                                                width={"60vw"}
                                                height={"75vh"}
                                                zIndex={"10000"}
                                            >
                                                <img
                                                    src={item}
                                                    alt="preview"
                                                    width={"100%"}
                                                    style={{ objectFit: 'contain' }}
                                                />
                                            </Modal>
                                        </div>
                                    ))
                                }
                            </div>
                        }
                        {isLoading ?
                            <Spin indicator={this.antIcon} /> :
                            (package_mockup.length < 3 && <UploadOutlined style={{ fontSize: 18, cursor: 'pointer' }} onClick={() => this._handleAddImage(_id)} />)
                        }
                        <input
                            type="file"
                            accept="image/*"
                            ref={el => (this.inputFileRefVariant[_id] = el)}
                            hidden
                            onChange={(e) => this._handleFileChange(e, _id)}
                        />
                    </div>
                )
            },
            className: 'table-cell-image'
        },
    ]

    components = {
        body: {
            row: EditableRow,
            cell: EditableCell,
        },
    }

    _handleChangeTab = (objectType, objectName) => {
        const { changeTab } = this.props

        this.setState({
            // carrier: objectName,
            objectType,
            objectName
        }, () => {
            changeTab(objectType, objectName)
        })
    }

    _onDeleteSkuTab = (objectType, objectName) => {
        const { onDeleteSizesByObject } = this.props

        if (typeof onDeleteSizesByObject === 'function') {
            onDeleteSizesByObject(objectType, objectName)
        }
    }

    _handleOpenDescribeVariant = () => {
        this.setState({ isOpenDescribeVariant: true })
    }

    _handleCloseDescribeVariant = () => {
        this.setState({ isOpenDescribeVariant: false })
        this.props.onGetSizes()
    }

    handleSave = (row) => {
        const { package_description = '', _id } = Object.assign({}, row)
        const newData = [...this.props.sizes].map(item => {
            if (item._id === _id) {
                return {
                    ...item,
                    isChange: true,
                    package_description,
                }
            }
            return item
        })

        this.props.onChangeSizes(newData)
    }

    handleUpdateDescription = async () => {
        this.setState({ loading: true })
        try {
            const { sizes, skuID } = this.props
            const { objectType, objectName } = this.state
            let hasError = false
            const newSizes = sizes.filter(size => !!size.isChange && size.isChange) || []
            const updateSizePromises = newSizes.map(async (item) => {
                try {
                    const { _id, sku, width, height, length, weight, additional_weight, weight_by_v, package_description, package_mockup } = Object.assign({}, item)
                    const payload = {
                        sku,
                        dimension: { width, height, length, weight, additional_weight },
                        weight_by_v,
                        optimization: {
                            type: objectType,
                            name: objectName
                        },
                        package_description: !!package_description ? package_description.trim() : '',
                        package_mockup
                    }

                    const { data: res } = await updateSkuSize(skuID, _id, payload)
                    const {success, message: mess} = res || {}
                    if (!success) {
                        hasError = true
                        throw new Error(mess)
                    }
                    hasError && message.success(`Cập nhật size ${sku} thành công!.`)

                } catch (error) {
                    hasError = true
                    message.error(error.message || "Lỗi không xác định.")
                }
            })

            await Promise.all(updateSizePromises)
            this.setState({ isOpenDescribeVariant: false })
            !hasError && message.success("Cập nhật size thành công!.")

        } catch (error) {
            message.error(error.message)
        } finally {
            this.setState({ loading: false })
        }
    }

    render() {
        const { objectType, objectName, isOpenDescribeVariant, loading } = this.state
        const { renderTableContent, isFFMView, brandOptions, listTab, sizes } = this.props
        const tableContent = renderTableContent()
        const isUpdateDescribeVariant = sizes.some(i => {
            const { package_description = '' } = Object.assign({}, i)
            if (!!package_description && package_description.trim().length < 20) return true
            if (!!package_description && package_description.trim().length > 500) return true
            return false
        })
        const columns = this.columns.map((col) => {
            if (!col.editable) {
                return col
            }
            return {
                ...col,
                onCell: (record) => ({
                    record,
                    editable: col.editable,
                    dataIndex: col.dataIndex,
                    title: col.title,
                    handleSave: this.handleSave,
                }),
            }
        })

        return (
            <div className="SkuSizeTabs mb-3">
                {
                    listTab.length > 0 ? (
                        <div className="tabSizes">
                            <ul className="mb-3">
                                <li onClick={() => this._handleChangeTab('shipping-carrier', 'default')}
                                    className={classNames('mb-1 item', objectType === 'shipping-carrier' && objectName === 'default' && 'active')}
                                    value="default">Mặc định
                                </li>

                                {
                                    listTab.length > 0 && listTab.map((item, index) => {
                                        const itemBrandMap = brandOptions.find(_item => _item.value === item.name && item.type === 'brand')
                                        const itemCarierMap = listLocal.find(_item => _item.value === item.name && item.type === 'shipping-carrier')

                                        if (itemBrandMap !== undefined || itemCarierMap !== undefined) {
                                            return (
                                                <li
                                                    className={classNames('mb-1 item HaveDelete', item.type, objectType === item.type && objectName === item.name && 'active')}
                                                    value={item.name}
                                                    key={index}
                                                >
                                                    <span onClick={() => this._handleChangeTab(item.type, item.name)}>
                                                        {item.name}
                                                    </span>
                                                    <Popconfirm
                                                        title={<span>Bạn có chắc chắn muốn xóa <span className='font-weight-bold'>{item.name}</span> không?</span>}
                                                        onConfirm={() => this._onDeleteSkuTab(item.type, item.name)}
                                                        okText='Xóa' cancelText='Hủy'
                                                    >
                                                        <span className="DeleteShippingCarrier">
                                                            <i className="icon-close2 text-danger" />
                                                        </span>
                                                    </Popconfirm>
                                                </li>
                                            )
                                        } else {
                                            return null
                                        }
                                    })
                                }
                            </ul>
                            <div className="contentTabs">
                                <table className="table">
                                    <thead className="TableHeadBoxItems">
                                        <TableHead isFFMView={isFFMView} onOpenDescribeVariant={this._handleOpenDescribeVariant} sizes={sizes} />
                                    </thead>
                                    {tableContent}
                                </table>
                            </div>
                        </div>
                    ) : (
                        <table className="table">
                            <thead className="TableHeadBoxItems">
                                <TableHead isFFMView={isFFMView} onOpenDescribeVariant={this._handleOpenDescribeVariant} sizes={sizes} />
                            </thead>
                            {tableContent}
                        </table>
                    )
                }
                {
                    isOpenDescribeVariant &&
                    <Modal
                        title={<span className='font-weight-bold'>Mô tả đóng gói variant</span>}
                        visible={isOpenDescribeVariant}
                        // onCancel={this._handleCloseDescribeVariant}
                        closable={false}
                        footer={[
                            <div className='d-flex align-items-center justify-content-between'>
                                <Button style={{ background: '#777777', color: "#ffffff" }} onClick={this._handleCloseDescribeVariant}>
                                    Hủy
                                </Button>
                                <Button
                                    style={{ background: '#3f97f6', color: "#ffffff" }}
                                    onClick={this.handleUpdateDescription}
                                    disabled={loading || isUpdateDescribeVariant}
                                    loading={loading}
                                >
                                    Cập nhật
                                </Button>
                            </div>
                        ]}
                        width={"1200px"}
                        style={{ maxWidth: '90%' }}
                        className="modalDescribeVariant"
                        zIndex={"9999"}
                    >
                        <Table
                            columns={columns}
                            dataSource={sizes}
                            pagination={false}
                            bordered
                            components={this.components}
                            rowClassName={() => 'editable-row'}
                        />
                    </Modal>
                }
            </div>
        )
    }
}

SkuSizeTabs.propTypes = {
    skuID: PropTypes.string,
    // onDeleteSizesByShippingCarrier: PropTypes.func.isRequired
}

export default SkuSizeTabs
